<style lang="less" scoped>
  @import "../../vars.less";
  .button-container {
    padding: @space-normal @space-normal;
    background-color: #fff;
  }
</style>

<template>
  <div class="customer">
    <van-search
      v-model="conditions.Name"
      :placeholder="$t('请输入完整客户名称或统一信用代码')" />
    <van-field
      readonly
      clickable
      :label="$t('国家/地区')"
      :value="currCountryName"
      :placeholder="$t('选择客户所属的国家或地区')"
      @click="showPicker = true"
      input-align="right"
      :border="false"
       right-icon="arrow-down"
    />
    <van-popup v-model="showPicker" round position="bottom" :get-container="getContainer">
      <van-picker :default-index="currIndex"
        show-toolbar
        :columns="countries"
        @cancel="showPicker = false"
        @confirm="onConfirm"
      />
    </van-popup>
    <div class="button-container">
      <van-button type="info" size="small" round block @click="query" >{{ $t('查询') }}</van-button>
    </div>
  </div>
</template>

<script>
import { Search, Field, Popup, Picker, Button, Toast } from 'vant'

export default {
  name: 'customer',
  components: {
    'van-search': Search,
    'van-field': Field,
    'van-popup': Popup,
    'van-picker': Picker,
    'van-button': Button
  },
  data () {
    return {
      currCountryName: '',
      currIndex: 0,
      conditions: {
        Name: '',
        CountryCode: ''
      },
      showPicker: false,
      countries: []
    }
  },
  watch: {
    countries (v) {
      if (v && v.length) {
        if (!this.conditions.CountryCode) {
          this.conditions.CountryCode = 'CN'
          for (let i = 0; i < this.countries.length; i++) {
            const c = this.countries[i]
            if (c.Code === 'CN') {
              this.currCountryName = c.Name
              this.currIndex = i
              break
            }
          }
        }
      }
    }
  },
  methods: {
    onConfirm (v) {
      this.conditions.CountryCode = v.Code
      this.currCountryName = v.Name
      this.showPicker = false
    },
    query () {
      if (!this.conditions.Name.trim()) {
        Toast(this.$t('请输入完整客户名称或统一信用代码'))
      } else if (this.conditions.Name.length < 6) {
        Toast(this.$t('客户名称或统一信用代码至少需要输入6个字符'))
      } else {
        this.$router.push({
          name: 'customer-list',
          query: {
            ...this.conditions,
            CountryName: this.currCountryName
          },
          params: {
            stackType: 'push'
          }
        })
      }
    },
    getContainer () {
      return window.document.body
    }
  },
  mounted () {
    this.$apis.basic.getCountries().then(res => {
      if (!res || !res.length) return
      this.countries = res.map(it => ({
        text: it.Name,
        ...it
      }))
    })
  }
}
</script>
